module.exports={
    // ===============================================

    // frontend hosted url test
    // frontendurl: 'https://sopanamstore.initstore.com'

    // ==================================================

    // apiurl:"https://connect.sopanamstore.initstore.com" ,

    // ===================================================

   
    
    // ===================================================
    
    // apiurl:"https://localhost:7164" 
    // apiurl:"https://store.api.initstore.com"


    // ===================================================

     // test api url

    // apiurl:"https://connect.sopanamstore.initstore.com" 

    // =============================================

    // production api url 

    apiurl:"https://storeapi.sopanam.in" , 

    // ==============================
//    
}